import {BuyerDetailsTabContent} from './BuyerDetailsTabContent';
import {BuyerFatcaCrsSupplementaryTabContent} from './BuyerFatcaCrsSupplementaryTabContent';

import type {BuyerDetailsTabContentProps} from './BuyerDetailsTabContent';
import type {FatcaCrsSupplementaryPayload} from '@sollapay/types';
import type {FC} from 'react';

export type SubTab = 'buyer-details' | 'fatca-crs';

export interface CreateBuyerTabContentProps extends BuyerDetailsTabContentProps {
  onSupplementaryValuesChange: (values: FatcaCrsSupplementaryPayload | null) => void;
  activeSubTab: SubTab;
}

export const CreateBuyerTabContent: FC<CreateBuyerTabContentProps> = ({
  trustAccountId,
  onSupplementaryValuesChange,
  activeSubTab,
  ...buyerProps
}) => {
  return (
    <div className="flex flex-col">
      <div hidden={activeSubTab !== 'buyer-details'}>
        <BuyerDetailsTabContent trustAccountId={trustAccountId} {...buyerProps} />
      </div>

      <div hidden={activeSubTab !== 'fatca-crs'} className="flex flex-col gap-6 py-4">
        <BuyerFatcaCrsSupplementaryTabContent
          trustAccountId={trustAccountId}
          buyerForm={buyerProps.form}
          saveError={buyerProps.saveError}
          onSupplementaryValuesChange={onSupplementaryValuesChange}
        />
      </div>
    </div>
  );
};
